// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3wyXM","title":"ClientReferral_title__-HoCk","itemText":"ClientReferral_itemText__1PAgh"};